import { render, staticRenderFns } from "./FileNotice.vue?vue&type=template&id=03534a2a&scoped=true"
import script from "./FileNotice.vue?vue&type=script&lang=js"
export * from "./FileNotice.vue?vue&type=script&lang=js"
import style0 from "./FileNotice.vue?vue&type=style&index=0&id=03534a2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03534a2a",
  null
  
)

export default component.exports